import { useTranslation } from "@redotech/redo-i18n";
import type { SubmitWarrantyRegistrationState } from "@redotech/redo-return-core-common/return-flow-step-valid";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const SubmitWarrantyRegistrationDetails = memo(
  function SubmitWarrantyRegistrationDetails({
    state,
    setState,
  }: StepTypeDetailsProps<SubmitWarrantyRegistrationState>) {
    const { t } = useTranslation();
    return <Text>{t("This submits a warranty registration")}</Text>;
  },
);
